import { reactive } from "vue";
import { useFilters } from "@/composables/filters/useFilters";

let instance = null;

export function useViewState() {
  if (instance) return instance;
  const filter = useFilters();
  const state = reactive({
    filters: {
      values: [],
      searchText: "",
      showFilterDialog: false,
      key: "readinessEmployees",
      clearSelection: "",
      needsRecalculation: false,
    },
    loading: {
      table: false,
    },
    table: {
      currentPage: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
      search: "",
    },
    showEmployeeBadgesList: false,
    selectedEmployee: null,
  });

  const applyFilters = (filters) => {
    const newArray = filters
      .map((item) => {
        if (item.value !== null) {
          if (typeof item === "string") {
            return item;
          } else if (
            typeof item === "object" &&
            // eslint-disable-next-line no-prototype-builtins
            item.hasOwnProperty("value")
          ) {
            return item.value;
          }
        }
      })
      .filter(Boolean);
    filter.setFilters({ key: state.filters.key, filters: newArray });
    state.filters.values = newArray;
    state.filters.showFilterDialog = false;
  };

  const removeFilters = (removedFilters) => {
    filter.setFilters({
      key: state.filters.key,
      filters: state.filters.values,
    });
    state.filters.clearSelection = removedFilters;
  };

  const getReadinessBadgeProps = (data) => {
    return {
      level: data.badge.level,
      dot: "No Dot",
      view: "ReadOnly",
      readinessView: true,
    };
  };
  const getOrgObjectCardProps = (obj) => {
    return {
      code: obj.code,
      name: obj.name,
      showIcon: false,
      removeUnderlineToName: true,
      id: obj.id,
    };
  };
  const getEvalEmpCardProps = (obj) => {
    return {
      name: obj.issued_by?.name,
      picture: obj.issued_by?.picture,
      userType: obj.issued_by?.userType,
      displayDate: formatDateToDisplay(obj.issued_by?.date),
    };
  };
  const formatDateToDisplay = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);

    if (isNaN(date)) return "Invalid Date";

    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  // Métodos para filtros
  const updateFilter = (filterName, value) => {
    if (filterName in state.filters) {
      state.filters[filterName] = value;
    }
  };

  const clearFilters = () => {
    state.filters = {
      status: "all",
      department: null,
      position: null,
    };
  };

  // Métodos para loading
  const setLoading = (key, value) => {
    if (key in state.loading) {
      state.loading[key] = value;
    }
  };
  const onClickBadgesCounterLevel = (item) => {
    state.showEmployeeBadgesList = true;
    state.selectedEmployee = item;
  };

  instance = {
    state,
    updateFilter,
    clearFilters,
    setLoading,
    getReadinessBadgeProps,
    getEvalEmpCardProps,
    applyFilters,
    removeFilters,
    getOrgObjectCardProps,
    onClickBadgesCounterLevel,
  };
  return instance;
}
